import PriceButton from 'components/Price/Button/component';

export default PriceButton;
